<template>
  <div>
    <v-card flat color="transparent" class="mt-7">
      <v-toolbar class="bdr secondary2light" :elevation="0" outlined>
        <v-toolbar-title
          class="grey--text text--darken-2"
          style="font-size: 18px"
          >{{ $t("notes") }}</v-toolbar-title
        >
      </v-toolbar>
    </v-card>
    <Notes :loading="loading"/>
  </div>
</template>
<script>
import Notes from "./notes/NotesList.vue";
export default {
  components: {
    Notes,
  },
  data() {
    return {
      loading: false,
    };
  },

  methods: {},
};
</script>
<style lang="scss" scoped>
.bdr {
  border: thin solid $secondary-color;
}
</style>
